import React, { Component } from 'react';
import EditIcon from '../assets/icons/edit.svg';
import Modal from '../CommonComponents/Modal';
import TimezoneList from './TimezoneList';
import ScheduleIcon from '../assets/icons/schedule.svg';
import calenderIcon from '../assets/icons/date_range.svg';
import AgentAvailability from './AgentAvailability';
import { api } from '../utils';
import ThemedButtons from '../CommonComponents/ThemedButtons';
import { CONFIG_MESSAGES } from '../constants';
import unCheckBox from '../assets/icons/check_box_unchecked.svg';
import CheckBoxChecked from '../assets/icons/check_box_checked.svg';
import DropDown from '../CommonComponents/Dropdown';
import unselected_btn from '../assets/icons/unselected_btn.svg';
import selected_btn from '../assets/icons/selected_btns.svg';
import FilledArrow from '../assets/icons/arrow_filled.svg';
import Check_new from '../assets/icons/check_new.svg';
import MultiSelect from '../CommonComponents/MultiSelect/index';

type Props = {
	selectedBotid: string;
	toasterNotify: Function;
	redirectionToLoginPage: Function;
};

type State = {
	showTimeZoneList: boolean;
	showAgentAvailability: boolean;
	showTimezoneToaster: boolean;
	displaySelectedTimezone: string;
	agentAvailabilityTime: { days: string; time: string }[];
	count: number;
	triggerOptions: { id: number; triggerOption: number; selected: boolean }[];
	shwDropDown: boolean;
	shwHandoffDropDown: boolean;
	detailInputPromptMsg: string;
	collectUserDetails: boolean;
	userDetailsName: boolean;
	userDetailscontact: boolean;
	userDetailsEmail: boolean;
	collectUserFeedback: boolean;
	feedbackPromptMsg: string;
	feedbackCommentPromptMsg: string;
	thankYouMsg: string;
	showQuickLinksAfterThankYouMsgFlag: boolean;
	nonComphrehendCountFlag: boolean;
	nonComphrehendCount: number;
	validationFailCountFlag: boolean;
	validationFailCount: number;
	detectNegativeSentimentFlag: boolean;
	requestByFlag: boolean;
	WHAgentUnAvalibilityMsg: string;
	NonWHAgentUnAvalibilityMsg: string;
	handoffConfirmationMsg: string;
	handoffMsg: string;
	waitTimeResponse: string;
	handoffCancelledMsg: string;
	showQuickLinksAfterhandoffCancelledMsgFlag: boolean;
	transferOrReleaseMsg: string;
	handoffEndMsg: string;
	showQuickLinksAfterhandoffEndMsgFlag: boolean;
	selectedIndex: number;
	checkValidationPopup: boolean;
	saveValidate: boolean;
	saveDataModalPopup: boolean;
	tabChangeDataModalPopup: boolean;
	countstate: number;
	kbotBotId: string;
	collectKbotDetails: boolean;
	toEmail: string;
	queuehandoffMsg: string;
	notifyAgentFlag: boolean;
	collectAgentAvailability: boolean;
	collectEmailId: boolean;
	queueFlag: boolean;
	NodeList: { nodeName: string; nodeId: number }[];
	selectedNode: { nodeName: string; nodeId: number }[];
	placeholders: string[];
	disableSaveBtn: boolean;
	agentAvailabilityList: { indexOfDay: number; time: string; day: string }[];
	availabilityType: string;
	roundRobinAutoAssignmentFlag: boolean;
	isTakeOverOptedChkFlag: boolean;
	nodeDetails: [];
	nodeIdDetails: [];
};

export default class GeneralTab extends Component<Props, State> {
	private myRef: React.RefObject<HTMLInputElement>;
	private myfeedbackRef: React.RefObject<HTMLInputElement>;
	private myfeedbackCommentRef: React.RefObject<HTMLInputElement>;
	private myThankyouRef: React.RefObject<HTMLInputElement>;
	private myKbotIdRef: React.RefObject<HTMLInputElement>;
	private shwHandoffDropDown: React.RefObject<HTMLInputElement>;
	private shwDropDown: React.RefObject<HTMLInputElement>;
	constructor(props: Props) {
		super(props);
		this.state = this.setInitialState();
		this.selectTimeZone = this.selectTimeZone.bind(this);
		this.agentAvailability = this.agentAvailability.bind(this);
		this.displaySelectedTimezone = this.displaySelectedTimezone.bind(this);
		this.onClose = this.onClose.bind(this);
		this.fetchAgentTimmings = this.fetchAgentTimmings.bind(this);
		this.fetchValuesBasedonIndex = this.fetchValuesBasedonIndex.bind(this);
		this.fetchConfigData = this.fetchConfigData.bind(this);
		this.fetchNodeList = this.fetchNodeList.bind(this);
		this.selectNodeList = this.selectNodeList.bind(this);
		this.selectNodeList = this.selectNodeList.bind(this);
		this.myRef = React.createRef();
		this.myfeedbackRef = React.createRef();
		this.myfeedbackCommentRef = React.createRef();
		this.myThankyouRef = React.createRef();
		this.myKbotIdRef = React.createRef();
		this.shwHandoffDropDown = React.createRef();
		this.shwDropDown = React.createRef();
	}
	setInitialState(): State {
		return {
			showTimeZoneList: false,
			showAgentAvailability: false,
			showTimezoneToaster: false,
			displaySelectedTimezone: '',
			agentAvailabilityTime: [],
			count: 0,
			triggerOptions: [
				{ id: 0, triggerOption: 1, selected: false },
				{ id: 1, triggerOption: 2, selected: false },
				{ id: 2, triggerOption: 3, selected: false },
				{ id: 3, triggerOption: 4, selected: false },
				{ id: 4, triggerOption: 5, selected: false },
			],
			shwDropDown: false,
			shwHandoffDropDown: false,
			detailInputPromptMsg:
				'Please share the following details before we transfer your chat',
			collectUserDetails: false,
			userDetailsName: false,
			userDetailscontact: false,
			userDetailsEmail: false,
			collectUserFeedback: false,
			feedbackPromptMsg:
				'Did speaking with our agent help in resolving your issue?',
			feedbackCommentPromptMsg: `I am sorry to hear that. Please tell us what went wrong. Or just say
      ‘skip’`,
			thankYouMsg:
				'Thanks for the feedback. Is there something else that I can help you with?',
			showQuickLinksAfterThankYouMsgFlag: false,
			nonComphrehendCountFlag: false,
			nonComphrehendCount: 1,
			validationFailCountFlag: false,
			validationFailCount: 1,
			detectNegativeSentimentFlag: false,
			requestByFlag: false,
			WHAgentUnAvalibilityMsg: '',
			NonWHAgentUnAvalibilityMsg: '',
			handoffConfirmationMsg: '',
			handoffMsg: '',
			waitTimeResponse: '',
			handoffCancelledMsg: '',
			transferOrReleaseMsg: '',
			handoffEndMsg: '',
			showQuickLinksAfterhandoffCancelledMsgFlag: false,
			showQuickLinksAfterhandoffEndMsgFlag: false,
			selectedIndex: -1,
			checkValidationPopup: false,
			saveValidate: false,
			saveDataModalPopup: false,
			tabChangeDataModalPopup: false,
			countstate: 0,
			kbotBotId: '',
			notifyAgentFlag: false,
			collectKbotDetails: false,
			toEmail: '',
			queuehandoffMsg: '',
			queueFlag: false,
			collectAgentAvailability: false,
			collectEmailId: false,
			NodeList: [],
			selectedNode: [{ nodeName: 'string', nodeId: -1 }],
			placeholders: [],
			disableSaveBtn: false,
			agentAvailabilityList: [],
			availabilityType: '',
			roundRobinAutoAssignmentFlag: false,
			isTakeOverOptedChkFlag: false,
			nodeDetails: [],
			nodeIdDetails: [],
		};
	}
	componentDidMount() {
		this.fetchAgentTimmings();
		this.fetchConfigData();
		document.addEventListener('click', this.handleClickOutside);
		this.fetchNodeList();
		//     notifyAgents
		// chatsInQueue
	}
	fetchConfigData() {
		let encodedbotId = encodeURIComponent(this.props.selectedBotid);
		if (
			this.props.selectedBotid !== '' &&
			this.props.selectedBotid !== undefined
		) {
			api(`getBotStudioConfiguration?botId=${encodedbotId}`).then((res) => {
				if (res.error === 'Authentication Failed') {
					this.props.redirectionToLoginPage();
				} else {
					// if (res.redirectToLogin === true) {
					// 	this.props.redirectionToLoginPage();
					// } else {
					if (res) {
						this.setState((prevState) => ({
							nonComphrehendCount: res.nonComphrehendCount,
							isTakeOverOptedChkFlag: res.isTakeOverOptedChkFlag,
							nonComphrehendCountFlag: res.nonComphrehendCountFlag,
							requestByFlag: res.requestByFlag,
							WHAgentUnAvalibilityMsg: res.WHAgentUnAvalibilityMsg,
							validationFailCountFlag: res.validationFailCountFlag,
							showQuickLinksAfterhandoffCancelledMsgFlag:
								res.showQuickLinksAfterhandoffCancelledMsgFlag,
							collectUserFeedback: res.collectUserFeedback,
							transferOrReleaseMsg: res.transferOrReleaseMsg,
							feedbackPromptMsg: res.feedbackPromptMsg,
							NonWHAgentUnAvalibilityMsg: res.NonWHAgentUnAvalibilityMsg,
							showQuickLinksAfterThankYouMsgFlag:
								res.showQuickLinksAfterThankYouMsgFlag,
							detectNegativeSentimentFlag: res.detectNegativeSentimentFlag,
							handoffCancelledMsg: res.handoffCancelledMsg,
							handoffMsg: res.handoffMsg,
							feedbackCommentPromptMsg: res.feedbackCommentPromptMsg,
							handoffConfirmationMsg: res.handoffConfirmationMsg,
							waitTimeResponse: res.waitTimeResponse,
							collectUserDetails: res.collectUserDetails,
							showQuickLinksAfterhandoffEndMsgFlag:
								res.showQuickLinksAfterhandoffEndMsgFlag,
							handoffEndMsg: res.handoffEndMsg,
							validationFailCount: res.validationFailCount,
							detailInputPromptMsg: res.detailInputPromptMsg,
							thankYouMsg: res.thankYouMsg,
							triggerOptions: prevState.triggerOptions.map((obj) =>
								obj.triggerOption === res.nonComphrehendCount
									? Object.assign(obj, { selected: true })
									: obj
							),
							nodeDetails: res.nodeToTriggerHandoff,
							// ? res.nodeToTriggerHandoff.split(`~`)
							// : [],
							nodeIdDetails: res.nodeId,
							// ? res.nodeId.split(`~`) : [],
							// selectedNode: [{ nodeName: res.nodeToTriggerHandoff, nodeId: res.nodeId }],
							// selectedNode: { nodeName: res.nodeToTriggerHandoff, nodeId: res.nodeId },
							kbotBotId: res.kbotBotId,
							toEmail: res.toEmail,
							queuehandoffMsg: res.queuehandoffMsg,
							queueFlag: res.queueFlag,
							collectKbotDetails: res.collectKbotDetails,
							notifyAgentFlag: res.notifyAgentFlag,
							collectAgentAvailability: res.collectAgentAvailability,
							collectEmailId: res.collectEmailId,
							placeholders: [
								res.detailInputPromptMsg,
								res.feedbackPromptMsg,
								res.feedbackCommentPromptMsg,
								res.thankYouMsg,
								res.WHAgentUnAvalibilityMsg,
								res.NonWHAgentUnAvalibilityMsg,
								res.handoffConfirmationMsg,
								res.handoffEndMsg,
								res.waitTimeResponse,
								res.handoffCancelledMsg,
								res.transferOrReleaseMsg,
								res.handoffEndMsg,
							],
							roundRobinAutoAssignmentFlag: res.roundRobinAutoAssignmentFlag,
						}));
						if (res.fieldForUserDeatils !== '') {
							this.setState(
								{
									userDetailsName: false,
									userDetailsEmail: false,
									userDetailscontact: false,
								},
								() => {
									if (res.fieldForUserDeatils.includes('name')) {
										this.setState({
											userDetailsName: true,
										});
									}
									if (res.fieldForUserDeatils.includes('email')) {
										this.setState({
											userDetailsEmail: true,
										});
									}
									if (res.fieldForUserDeatils.includes('contact_no')) {
										this.setState({
											userDetailscontact: true,
										});
									}
								}
							);
						}
					}
				}
			});
		}
	}
	fetchAgentTimmings() {
		let encodedbotId = encodeURIComponent(this.props.selectedBotid);
		if (
			this.props.selectedBotid !== '' &&
			this.props.selectedBotid !== undefined
		) {
			api(`getAgentAvailibilityForBot?botId=${encodedbotId}`).then((res) => {
				let data = res.agentAvailibility;
				this.setState({
					displaySelectedTimezone: res.timezone,
					agentAvailabilityList: data.map((availability: any, i: any) => ({
						indexOfDay: availability.indexOfDay,
						time: availability.time,
						day: availability.day,
					})),
					availabilityType: res.type,
				});
				let dayTimeMapping: {
					day: string;
					time: string;
					indexOfDay: number;
				}[] = [];

				for (let i = 0; i < data.length; i++) {
					const mapping = data[i];
					const lastMapping = dayTimeMapping[dayTimeMapping.length - 1] || {
						time: '',
					};
					if (
						mapping.time === lastMapping.time &&
						mapping.indexOfDay - lastMapping.indexOfDay === 1
					) {
						dayTimeMapping[dayTimeMapping.length - 1] = {
							...lastMapping,
							day: lastMapping.day.substr(0, 3) + ' - ' + mapping.day,
							indexOfDay: mapping.indexOfDay,
						};
					} else {
						dayTimeMapping.push({
							day: mapping.day,
							time: mapping.time,
							indexOfDay: mapping.indexOfDay,
						});
					}
				}
				this.setState({
					agentAvailabilityTime: dayTimeMapping.map((list: any) => ({
						days: list.day,
						time: list.time,
					})),
				});
			});
		}
	}
	fetchNodeList() {
		let encodedbotId = encodeURIComponent(this.props.selectedBotid);
		if (
			this.props.selectedBotid !== '' &&
			this.props.selectedBotid !== undefined
		) {
			api(`getNodesForBot?botId=${encodedbotId}`).then((res) => {
				this.setState({
					NodeList: res.NodesForBot.map((node: any) => ({
						nodeName: node.nodeName,
						nodeId: node.nodeId,
					})),
				});
			});
		}
	}
	componentDidUpdate(prevProps: Props, prevState: State) {
		if (this.props.selectedBotid !== prevProps.selectedBotid) {
			const elem = document.querySelector('.general-tab-w .grid-system');
			if (elem) {
				elem.scrollTop = 0;
			}
		}
		if (
			prevState.nonComphrehendCountFlag !==
				this.state.nonComphrehendCountFlag ||
			prevState.validationFailCountFlag !==
				this.state.validationFailCountFlag ||
			prevState.detectNegativeSentimentFlag !==
				this.state.detectNegativeSentimentFlag ||
			prevState.requestByFlag !== this.state.requestByFlag ||
			prevState.WHAgentUnAvalibilityMsg !==
				this.state.WHAgentUnAvalibilityMsg ||
			prevState.NonWHAgentUnAvalibilityMsg !==
				this.state.NonWHAgentUnAvalibilityMsg ||
			prevState.handoffConfirmationMsg !== this.state.handoffConfirmationMsg ||
			prevState.handoffMsg !== this.state.handoffMsg ||
			prevState.waitTimeResponse !== this.state.waitTimeResponse ||
			prevState.handoffCancelledMsg !== this.state.handoffCancelledMsg ||
			prevState.transferOrReleaseMsg !== this.state.transferOrReleaseMsg ||
			prevState.handoffEndMsg !== this.state.handoffEndMsg ||
			prevState.userDetailsName !== this.state.userDetailsName ||
			prevState.userDetailsEmail !== this.state.userDetailsEmail ||
			prevState.userDetailscontact !== this.state.userDetailscontact
		) {
			this.setState({
				countstate: this.state.countstate + 1,
			});
		}

		if (
			(Object.is(
				prevState.agentAvailabilityTime,
				this.state.agentAvailabilityTime
			) &&
				prevState.count !== this.state.count) ||
			prevProps.selectedBotid !== this.props.selectedBotid
		) {
			this.fetchAgentTimmings();
			this.fetchConfigData();
		}
		if (prevProps.selectedBotid !== this.props.selectedBotid) {
			this.fetchNodeList();
		}
	}

	componentWillUnmount() {
		document.removeEventListener('click', this.handleClickOutside);
	}
	handleClickOutside = (event: any) => {
		if (
			this.shwHandoffDropDown.current &&
			!this.shwHandoffDropDown.current.contains(event.target)
		) {
			this.setState({
				shwHandoffDropDown: false,
			});
		}
		if (
			this.shwDropDown.current &&
			!this.shwDropDown.current.contains(event.target)
		) {
			this.setState({
				shwDropDown: false,
			});
		}
	};
	selectTimeZone() {
		this.setState({
			showTimeZoneList: true,
		});
	}
	selectText(id: number) {
		this.setState({
			selectedIndex: id,
		});
	}
	agentAvailability() {
		this.setState({
			showAgentAvailability: true,
		});
	}
	displaySelectedTimezone(timezone: string) {
		this.setState({
			displaySelectedTimezone: timezone,
		});
	}
	onClose() {
		this.setState({
			showTimeZoneList: false,
			showTimezoneToaster: !this.state.showTimezoneToaster,
		});
		this.fetchAgentTimmings();
		this.props.toasterNotify('Time zone updated');
	}
	fetchValuesBasedonIndex(event: any, index: number) {
		if (index === 0) {
			this.setState({
				WHAgentUnAvalibilityMsg: event.target.value,
			});
		} else if (index === 1) {
			this.setState({
				NonWHAgentUnAvalibilityMsg: event.target.value,
			});
		} else if (index === 2) {
			this.setState({
				handoffConfirmationMsg: event.target.value,
			});
		} else if (index === 3) {
			this.setState({
				handoffMsg: event.target.value,
			});
		} else if (index === 4) {
			this.setState({
				waitTimeResponse: event.target.value,
			});
		} else if (index === 5) {
			this.setState({
				handoffCancelledMsg: event.target.value,
			});
		} else if (index === 6) {
			this.setState({
				transferOrReleaseMsg: event.target.value,
			});
		} else if (index === 7) {
			this.setState({
				handoffEndMsg: event.target.value,
			});
		}
	}
	setBotStudioSetting() {
		var data1 = '';
		if (
			this.state.userDetailsEmail &&
			this.state.userDetailsName &&
			this.state.userDetailscontact
		) {
			data1 = 'name,email,contact_no';
		} else if (this.state.userDetailsEmail && this.state.userDetailsName) {
			data1 = 'name,email';
		} else if (this.state.userDetailscontact && this.state.userDetailsName) {
			data1 = 'name,contact_no';
		} else if (this.state.userDetailscontact && this.state.userDetailsEmail) {
			data1 = 'email,contact_no';
		} else if (this.state.userDetailsName) {
			data1 = 'name';
		} else if (this.state.userDetailsEmail) {
			data1 = 'email';
		} else if (this.state.userDetailscontact) {
			data1 = 'contact_no';
		}

		let data = {
			botId: this.props.selectedBotid,
			allData: {
				nonComphrehendCountFlag: this.state.nonComphrehendCountFlag,
				isTakeOverOptedChkFlag: this.state.isTakeOverOptedChkFlag,
				nonComphrehendCount: this.state.nonComphrehendCount,
				validationFailCountFlag: this.state.validationFailCountFlag,
				validationFailCount: this.state.validationFailCount,
				detectNegativeSentimentFlag: this.state.detectNegativeSentimentFlag,
				requestByFlag: this.state.requestByFlag,
				nodeToTriggerHandoff: this.state.nodeDetails,
				// nodeToTriggerHandoff: this.state.selectedNode.nodeName,
				collectUserDetails: this.state.collectUserDetails,
				fieldForUserDeatils: data1,
				detailInputPromptMsg: this.state.detailInputPromptMsg,
				collectUserFeedback: this.state.collectUserFeedback,
				feedbackPromptMsg: this.state.feedbackPromptMsg,
				feedbackCommentPromptMsg: this.state.feedbackCommentPromptMsg,
				thankYouMsg: this.state.thankYouMsg,
				showQuickLinksAfterThankYouMsgFlag:
					this.state.showQuickLinksAfterThankYouMsgFlag,
				WHAgentUnAvalibilityMsg: this.state.WHAgentUnAvalibilityMsg,
				NonWHAgentUnAvalibilityMsg: this.state.NonWHAgentUnAvalibilityMsg,
				handoffConfirmationMsg: this.state.handoffConfirmationMsg,
				handoffMsg: this.state.handoffMsg,
				waitTimeResponse: this.state.waitTimeResponse,
				handoffCancelledMsg: this.state.handoffCancelledMsg,
				showQuickLinksAfterhandoffCancelledMsgFlag:
					this.state.showQuickLinksAfterhandoffCancelledMsgFlag,
				transferOrReleaseMsg: this.state.transferOrReleaseMsg,
				handoffEndMsg: this.state.handoffEndMsg,
				showQuickLinksAfterhandoffEndMsgFlag:
					this.state.showQuickLinksAfterhandoffEndMsgFlag,
				kbotBotId: this.state.kbotBotId,
				collectKbotDetails: this.state.collectKbotDetails,
				toEmail: this.state.toEmail,
				queuehandoffMsg: this.state.queuehandoffMsg,
				queueFlag: this.state.queueFlag,
				notifyAgentFlag: this.state.notifyAgentFlag,
				collectAgentAvailability: this.state.collectAgentAvailability,
				collectEmailId: this.state.collectEmailId,
				nodeId: this.state.nodeIdDetails,
				// nodeId: +this.state.selectedNode.nodeId,
				roundRobinAutoAssignmentFlag: this.state.roundRobinAutoAssignmentFlag,
			},
		};
		if (
			this.state.WHAgentUnAvalibilityMsg === '' ||
			this.state.NonWHAgentUnAvalibilityMsg === '' ||
			this.state.handoffConfirmationMsg === '' ||
			this.state.handoffMsg === '' ||
			this.state.waitTimeResponse === '' ||
			this.state.handoffCancelledMsg === '' ||
			this.state.transferOrReleaseMsg === '' ||
			this.state.handoffEndMsg === '' ||
			this.state.queuehandoffMsg === '' ||
			// this.state.toEmail === '' ||
			(this.state.collectKbotDetails && this.state.kbotBotId === '')
		) {
			this.setState({
				checkValidationPopup: !this.state.checkValidationPopup,
				saveDataModalPopup: false,
			});
		} else {
			this.setState({
				disableSaveBtn: true,
			});
			api('setBotStudioConfiguration', 'POST', data).then((res) => {
				if (res.result === true) {
					this.fetchConfigData();
					this.setState(
						{
							disableSaveBtn: false,
						},
						() => {
							this.props.toasterNotify('Changes Saved');
						}
					);
				}
			});
		}
	}
	areAllHandoffTriggersDeselected = () => {
		return (
			!this.state.nonComphrehendCountFlag &&
			!this.state.validationFailCountFlag &&
			!this.state.detectNegativeSentimentFlag &&
			!this.state.requestByFlag
		);
	};
	selectNodeList(nodeName: any, nodeId: any) {
		// const value = this.state.NodeList.filter((data) => {
		//   return data.nodeName === val;
		// });
		// const textdata = this.state.NodeList.filter((data) => {
		//   return data.nodeId === text;
		// });

		// console.log('selected one', nodeName, nodeId);

		// changed for now
		// var value = '';
		// var textdata = '';
		// for (var i = 0; i < nodeName.length; i++) {
		//   value = value + nodeName[i] + `~`;
		//   textdata = textdata + nodeId[i] + `~`;
		// }

		// console.log('filtered one', value, textdata);
		// this.setState({
		//   selectedNode: val ? value[0] : { nodeName: '', nodeId: -1 },
		// });

		// changed for now
		// this.setState({
		//   nodeDetails: value.slice(0, -1),
		//   nodeIdDetails: textdata.slice(0, -1),
		// });

		this.setState({
			nodeDetails: nodeName,
			nodeIdDetails: nodeId,
		});
	}
	checkEmailValidation(email: string) {
		var re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
		if (re.test(email)) {
			return false;
		} else {
			return true;
		}
	}
	render() {
		return (
			<div className='general-tab-w'>
				<div className='save-configure-details'>
					<div style={{ marginRight: '36px' }}>
						<ThemedButtons
							title={this.state.disableSaveBtn ? 'Saving...' : 'Save Changes'}
							theme='0'
							onClick={() => {
								this.setBotStudioSetting();
							}}
							style={{ padding: '8px 24px', width: '90px' }}
							disabled={!this.state.disableSaveBtn}
						/>
					</div>
				</div>
				<div className='grid-system'>
					<div>
						<div className='first-config-wrapper'>
							<div className='frst-config-hearder'>TIME SETTINGS</div>
							<div>
								<div className='timezone'>Agent availability timings</div>
								<div className='working-hrs'>
									Handoff will be triggered by the bot only during these timings
								</div>
								<div style={{ display: 'flex' }}>
									<div className='agent-availability'>
										<table className='agent-availability-data'>
											<thead>
												<tr className='agent-availability-header'>
													<th>
														<div className='th-align'>
															<img
																src={calenderIcon}
																alt='calender'
																style={{ marginRight: '5px' }}
															/>
															Working days
														</div>
													</th>
													<th>
														<div className='th-align'>
															<img
																src={ScheduleIcon}
																alt='shedule'
																style={{ marginRight: '5px' }}
															/>
															Working Hours
														</div>
													</th>
													<th>
														<div
															style={{ display: 'flex' }}
															onClick={this.agentAvailability}
															className='pointing-icon'>
															<img src={EditIcon} alt='editicon' />
														</div>
													</th>
												</tr>
											</thead>
											<tbody>
												{this.state.agentAvailabilityTime.map((data, index) => {
													return (
														<tr
															style={{
																fontSize: '14px',
																letterSpacing: '-0.21px',
															}}
															key={index}>
															<td>{data.days}</td>
															<td>{data.time}</td>
														</tr>
													);
												})}
											</tbody>
										</table>
									</div>
								</div>
								<Modal
									isOpen={this.state.showAgentAvailability}
									title='Agent availability'
									onClose={() => {
										this.setState({
											showAgentAvailability: false,
										});
									}}>
									<AgentAvailability
										selectedBotid={this.props.selectedBotid}
										onSave={(val: string) => {
											this.setState({
												showAgentAvailability:
													!this.state.showAgentAvailability,
												count: this.state.count + 1,
											});
										}}
										agentAvailabilityList={this.state.agentAvailabilityList}
										availabilityType={this.state.availabilityType}
									/>
								</Modal>
							</div>
							<div className='timezone-wrapper'>
								<div className='timezone'>Agent time zone</div>
								<div className='working-hrs'>
									Agent working hours are in this time zone
								</div>
								<div className='timezone-data'>
									<div
										className='display-timezone pointing-icon'
										onClick={this.selectTimeZone}>
										{this.state.displaySelectedTimezone}
									</div>
									{/* <div className='edit-timezone pointing-icon'>
                    <img src={EditIcon} alt='editicon' />
                  </div> */}
								</div>
								<Modal
									isOpen={this.state.showTimeZoneList}
									title='Select time zone'
									onClose={() => {
										this.setState({
											showTimeZoneList: false,
										});
									}}>
									<TimezoneList
										onClose={this.onClose}
										displaySelectedTimezone={this.displaySelectedTimezone}
										selectedBotid={this.props.selectedBotid}
										selectedTimeZone={this.state.displaySelectedTimezone}
									/>
								</Modal>
							</div>
						</div>

						<div className='first-config-wrapper'>
							<div className='frst-config-hearder'>HANDOFF TRIGGERS</div>
							<div
								className={`third-config-wrapper`}
								style={{
									marginTop: '25px',
									color: 'red',
									display: this.areAllHandoffTriggersDeselected()
										? 'block'
										: 'none',
								}}>
								Select at least one event that should trigger automatic handoff
							</div>
							<div style={{ marginTop: '15px' }}>
								<div style={{ display: 'flex' }}>
									<img
										src={
											this.state.nonComphrehendCountFlag
												? CheckBoxChecked
												: unCheckBox
										}
										alt='checkbox'
										style={{ width: '20px', height: '20px' }}
										className='pointing-icon'
										onClick={() => {
											this.setState({
												nonComphrehendCountFlag:
													!this.state.nonComphrehendCountFlag,
											});
										}}
									/>
									<span
										className='third-config-wrapper'
										style={{ marginLeft: '5px' }}>
										Consecutive non comprehension of user’s query
									</span>
								</div>
								{this.state.nonComphrehendCountFlag && (
									<div
										style={{
											display: 'flex',
											marginLeft: '25px',
											justifyContent: 'space-between',
										}}>
										<div
											className='third-config-wrapper'
											style={{
												paddingLeft: '10px',
												marginTop: '10px',
												borderLeft: '1px solid #0000001a',
											}}>
											No. of consecutive queries to handoff after
										</div>
										<div>
											<div
												onClick={() => {
													this.setState({
														shwHandoffDropDown: !this.state.shwHandoffDropDown,
													});
												}}
												className='trigger-options'
												ref={this.shwHandoffDropDown}>
												<span style={{ fontSize: '14px' }}>
													{this.state.nonComphrehendCount}
												</span>
												<img
													src={FilledArrow}
													alt='drop-arrow'
													className='pointing-icon'
												/>
											</div>
											{this.state.shwHandoffDropDown && (
												<div className='selection-of-user'>
													<div
														className='adding-user-options'
														style={{
															width: '33px',
															height: 'auto',
															padding: '10px',
															color: 'rgba(0,0,0,0.8)',
														}}>
														{this.state.triggerOptions.map((val, i) => {
															return (
																<div
																	key={i}
																	onClick={() => {
																		this.setState((prevState) => ({
																			nonComphrehendCount: val.triggerOption,
																			shwHandoffDropDown:
																				!this.state.shwHandoffDropDown,
																		}));
																	}}
																	style={{
																		display: 'flex',
																		justifyContent: 'space-between',
																		alignItems: 'center',
																	}}>
																	<>{val.triggerOption}</>
																	{this.state.nonComphrehendCount ===
																		val.triggerOption && (
																		<img
																			src={
																				this.state.nonComphrehendCount ===
																				val.triggerOption
																					? Check_new
																					: ''
																			}
																			alt='checked'
																			style={{ width: '16px', height: '16px' }}
																		/>
																	)}
																</div>
															);
														})}
													</div>
												</div>
											)}
										</div>
									</div>
								)}
							</div>
							<div style={{ marginTop: '15px' }}>
								<div style={{ display: 'flex' }} className='pointing-icon'>
									<img
										src={
											this.state.validationFailCountFlag
												? CheckBoxChecked
												: unCheckBox
										}
										alt='checkbox'
										style={{ width: '20px', height: '20px' }}
										onClick={() => {
											this.setState({
												validationFailCountFlag:
													!this.state.validationFailCountFlag,
											});
										}}
									/>
									<span
										className='third-config-wrapper'
										style={{ marginLeft: '5px' }}>
										Consecutive validation failure of a task
									</span>
								</div>
								{this.state.validationFailCountFlag && (
									<div
										style={{
											display: 'flex',
											marginLeft: '25px',
											justifyContent: 'space-between',
										}}>
										<div
											className='third-config-wrapper'
											style={{
												paddingLeft: '10px',
												marginTop: '10px',
												borderLeft: '1px solid #0000001a',
											}}>
											No. of consecutive failures to handoff after
										</div>
										<div>
											<div
												onClick={() => {
													this.setState({
														shwDropDown: !this.state.shwDropDown,
													});
												}}
												className='trigger-options'
												ref={this.shwDropDown}>
												<span style={{ fontSize: '14px' }}>
													{this.state.validationFailCount}
												</span>
												<img src={FilledArrow} alt='drop-arrow' />
											</div>
											{this.state.shwDropDown && (
												<div className='selection-of-user'>
													<div
														className='adding-user-options'
														style={{
															width: '33px',
															height: 'auto',
															padding: '10px',
															color: 'rgba(0,0,0,0.8)',
														}}>
														{this.state.triggerOptions.map((val, i) => {
															return (
																<div
																	key={i}
																	onClick={() => {
																		this.setState((prevState) => ({
																			validationFailCount: val.triggerOption,
																			shwDropDown: !this.state.shwDropDown,
																		}));
																	}}
																	style={{
																		display: 'flex',
																		justifyContent: 'space-between',
																		alignItems: 'center',
																	}}>
																	<>{val.triggerOption}</>
																	{this.state.validationFailCount ===
																		val.triggerOption && (
																		<img
																			src={
																				this.state.validationFailCount ===
																				val.triggerOption
																					? Check_new
																					: ''
																			}
																			alt='checked'
																			style={{ width: '16px', height: '16px' }}
																		/>
																	)}
																</div>
															);
														})}
													</div>
												</div>
											)}
										</div>
									</div>
								)}
							</div>
							<div style={{ marginTop: '15px' }}>
								<div style={{ display: 'flex' }}>
									<img
										src={
											this.state.detectNegativeSentimentFlag
												? CheckBoxChecked
												: unCheckBox
										}
										alt='checkbox'
										style={{ width: '20px', height: '20px' }}
										className='pointing-icon'
										onClick={() => {
											this.setState({
												detectNegativeSentimentFlag:
													!this.state.detectNegativeSentimentFlag,
											});
										}}
									/>
									<span
										className='third-config-wrapper'
										style={{ marginLeft: '5px' }}>
										Detection of negative sentiment in user’s query
									</span>
								</div>
							</div>
							<div style={{ marginTop: '15px' }}>
								<div style={{ display: 'flex' }}>
									<img
										src={
											this.state.requestByFlag ? CheckBoxChecked : unCheckBox
										}
										alt='checkbox'
										style={{ width: '20px', height: '20px' }}
										className='pointing-icon'
										onClick={() => {
											this.setState({
												requestByFlag: !this.state.requestByFlag,
											});
										}}
									/>
									<span
										className='third-config-wrapper'
										style={{ marginLeft: '5px' }}>
										Request by user
									</span>
								</div>
								{this.state.requestByFlag && (
									<div
										style={{
											display: 'flex',
											flexDirection: 'column',
											borderLeft: '1px solid #0000001a',
											marginLeft: '25px',
											marginTop: '10px',
										}}>
										<div
											className='third-config-wrapper'
											style={{ marginLeft: '10px' }}>
											Select the node that will trigger the handoff
										</div>
										{/* check here */}
										<div>
											{/* <DropDown
                        // options={this.state.NodeList.map((node) => node.nodeName)}
                        options={this.state.NodeList}
                        onSelectionChange={(val: any) => {
                          this.selectNodeList(val);
                        }}
                        placeholder='Select Nodes'
                        filterType='external'
                        selected={this.state.selectedNode.length + 'Nodes Selected'}
                        // selected={this.state.selectedNode.nodeName}
                      /> */}

											<MultiSelect
												// memberVisible={this.state.memberVisible}
												options={this.state.NodeList.map(
													(node) => node.nodeName
												)}
												value={this.state.NodeList.map((node) => node.nodeId)}
												// type='members'
												// handleDropDown={this.handleDropDown}
												selectNodeList={this.selectNodeList}
												nodeDetails={this.state.nodeDetails}
												nodeIdDetails={this.state.nodeIdDetails}
											/>
										</div>
									</div>
								)}
							</div>
						</div>
						<div
							className='first-config-wrapper'
							style={{ paddingBottom: '44px' }}>
							<div className='frst-config-hearder'>CHAT TAKE OVER</div>
							<div
								style={{
									marginTop: '44px',
									display: 'flex',
									justifyContent: 'space-between',
								}}>
								<div className='config-msg-header'>
									Let agents take over chats from bot
								</div>
								<div>
									<img
										src={
											this.state.isTakeOverOptedChkFlag
												? selected_btn
												: unselected_btn
										}
										alt='unselectedbtns'
										className='pointing-icon'
										onClick={() => {
											this.setState({
												isTakeOverOptedChkFlag:
													!this.state.isTakeOverOptedChkFlag,
											});
										}}
									/>
								</div>
							</div>
							<div
								className='config-msg-usecase'
								style={{ marginTop: '10px', marginBottom: '22px' }}>
								Provides agents the option to proactively take chats over from
								the bot, even if handoff is not triggered.
							</div>
						</div>

						<div
							className='first-config-wrapper'
							style={{ paddingBottom: '44px' }}>
							<div className='frst-config-hearder'>AUTO-ASSIGNING CHATS</div>
							<div
								style={{
									marginTop: '44px',
									display: 'flex',
									justifyContent: 'space-between',
								}}>
								<div className='config-msg-header'>
									Auto-assign chats to agents
								</div>
								<div>
									<img
										src={
											this.state.roundRobinAutoAssignmentFlag
												? selected_btn
												: unselected_btn
										}
										alt='unselectedbtns'
										className='pointing-icon'
										onClick={() => {
											this.setState({
												roundRobinAutoAssignmentFlag:
													!this.state.roundRobinAutoAssignmentFlag,
											});
										}}
									/>
								</div>
							</div>
							<div className='config-msg-usecase' style={{ marginTop: '10px' }}>
								The chats for which handoff is triggered will be automatically
								assigned to agents based on their availability and the queues
								that they have been assigned
							</div>
						</div>

						<div className='first-config-wrapper'>
							<div className='frst-config-hearder'>USER DETAILS COLLECTION</div>
							<div
								style={{
									marginTop: '31px',
									display: 'flex',
									justifyContent: 'space-between',
								}}>
								<div className='config-msg-header'>
									Collect user details before handoff
								</div>
								<div
									className='pointing-icon'
									onClick={() => {
										this.setState({
											collectUserDetails: !this.state.collectUserDetails,
										});
									}}>
									<img
										src={
											this.state.collectUserDetails
												? selected_btn
												: unselected_btn
										}
										alt='unselectedbtns'
									/>
								</div>
							</div>
							<div className='config-msg-usecase'>
								Before the user is put into a queue, a form will collect few
								personal details from them to help with analytics
							</div>
							{this.state.collectUserDetails && (
								<>
									<div
										className='config-msg-footer'
										style={{
											color: 'rgba(0, 0, 0, 0.6)',
											letterSpacing: '-0.21px',
											marginTop: '19px',
										}}>
										Select the details which should be collected
									</div>
									<div style={{ borderLeft: '2px solid #0000001a' }}>
										<span
											style={{
												display: 'flex',
												alignItems: 'center',
												marginLeft: '10px',
												marginTop: '10px',
											}}>
											<img
												src={
													this.state.userDetailsName
														? CheckBoxChecked
														: unCheckBox
												}
												alt='checkbox'
												style={{ width: '20px', height: '20px' }}
												className='pointing-icon'
												onClick={() => {
													this.setState({
														userDetailsName: !this.state.userDetailsName,
													});
												}}
											/>
											<span
												style={{ marginLeft: '10px' }}
												className='third-config-wrapper'>
												Name
											</span>
										</span>
										<span
											style={{
												display: 'flex',
												alignItems: 'center',
												marginLeft: '10px',
												marginTop: '10px',
											}}>
											<img
												src={
													this.state.userDetailsEmail
														? CheckBoxChecked
														: unCheckBox
												}
												alt='checkbox'
												style={{ width: '20px', height: '20px' }}
												className='pointing-icon'
												onClick={() => {
													this.setState({
														userDetailsEmail: !this.state.userDetailsEmail,
													});
												}}
											/>
											<span
												style={{ marginLeft: '10px' }}
												className='third-config-wrapper'>
												Email
											</span>
										</span>
										<span
											style={{
												display: 'flex',
												alignItems: 'center',
												marginLeft: '10px',
												marginTop: '10px',
											}}>
											<img
												src={
													this.state.userDetailscontact
														? CheckBoxChecked
														: unCheckBox
												}
												alt='checkbox'
												style={{ width: '20px', height: '20px' }}
												className='pointing-icon'
												onClick={() => {
													this.setState({
														userDetailscontact: !this.state.userDetailscontact,
													});
												}}
											/>
											<span
												style={{ marginLeft: '10px' }}
												className='third-config-wrapper'>
												Phone number
											</span>
										</span>
									</div>
									<div style={{ marginTop: '20px', marginBottom: '26px' }}>
										<div className='sec-config-hearder'>
											User details input prompt
										</div>
										<div className='config-msg-usecase'>
											Message asking the the user to input their details
										</div>
										<input
											type='text'
											style={{
												width: '100%',
												marginTop: '-3px',
											}}
											className='config-msg-footer'
											value={this.state.detailInputPromptMsg}
											ref={this.myRef}
											placeholder={'e.g. ' + this.state.placeholders[0]}
											onChange={(event) => {
												this.setState({
													detailInputPromptMsg: event.target.value,
												});
											}}
											required={true}
										/>
										{this.state.detailInputPromptMsg === '' && (
											<div className='config-empty-msg'>
												Please provide a user details input prompt
											</div>
										)}
									</div>
								</>
							)}
						</div>

						<div className='first-config-wrapper'>
							<div className='frst-config-hearder'>
								USER FEEDBACK COLLECTION
							</div>
							<div
								style={{
									marginTop: '34px',
									display: 'flex',
									justifyContent: 'space-between',
								}}>
								<div className='config-msg-header'>Collect user feedback</div>
								<div>
									<img
										src={
											this.state.collectUserFeedback
												? selected_btn
												: unselected_btn
										}
										alt='unselectedbtns'
										className='pointing-icon'
										onClick={() => {
											this.setState({
												collectUserFeedback: !this.state.collectUserFeedback,
											});
										}}
									/>
								</div>
							</div>
							<div className='config-msg-usecase'>
								User feedback will be collected about their chat experience with
								the agents after the chat is handed back to the bot
							</div>
							{this.state.collectUserFeedback && (
								<>
									<div style={{ marginTop: '20px' }}>
										<div className='sec-config-hearder'>Feedback prompt</div>
										<div className='config-msg-usecase'>
											A prompt asking the user if their issue was resolved. The
											user can select ‘Yes’ for resolved and ‘No’ for not
											resolved
										</div>
										<input
											type='text'
											style={{
												width: '100%',
												marginTop: '-5px',
											}}
											className='config-msg-footer'
											value={this.state.feedbackPromptMsg}
											placeholder={'e.g. ' + this.state.placeholders[1]}
											onChange={(event) => {
												this.setState({
													feedbackPromptMsg: event.target.value,
												});
											}}
											ref={this.myfeedbackRef}
											onFocus={(event) => event.target.select()}
											required={true}
										/>
										{this.state.feedbackPromptMsg === '' && (
											<div className='config-empty-msg'>
												Please provide a feedback prompt
											</div>
										)}
									</div>
									<div style={{ marginTop: '20px' }}>
										<div className='sec-config-hearder'>
											Feedback comment prompt
										</div>
										<div className='config-msg-usecase'>
											This prompt asks the user to elaborate on their feedback
											if they reported their issue as not resolved
										</div>
										<input
											type='text'
											style={{
												width: '100%',
												marginTop: '-5px',
											}}
											ref={this.myfeedbackCommentRef}
											className='config-msg-footer'
											value={this.state.feedbackCommentPromptMsg}
											placeholder={'e.g. ' + this.state.placeholders[2]}
											onChange={(event) => {
												this.setState({
													feedbackCommentPromptMsg: event.target.value,
												});
											}}
											onFocus={(event) => event.target.select()}
											required={true}
										/>
										{this.state.feedbackCommentPromptMsg === '' && (
											<div className='config-empty-msg'>
												Please provide a feedback comment prompt
											</div>
										)}
									</div>
									<div style={{ marginTop: '20px' }}>
										<div className='sec-config-hearder'>Thank you message</div>
										<div className='config-msg-usecase'>
											Shown after the user gives their feedback & comment
										</div>
										<input
											type='text'
											style={{
												width: '100%',
												marginTop: '-5px',
											}}
											ref={this.myThankyouRef}
											className='config-msg-footer'
											value={this.state.thankYouMsg}
											placeholder={'e.g. ' + this.state.placeholders[3]}
											onChange={(event) => {
												this.setState({ thankYouMsg: event.target.value });
											}}
											onFocus={(event) => event.target.select()}
											required={true}
										/>
										{this.state.thankYouMsg === '' && (
											<div className='config-empty-msg'>
												Please provide a thank you message
											</div>
										)}
									</div>
									<div
										style={{
											display: 'flex',
											alignItems: 'center',
											marginTop: '10px',
											marginBottom: '26px',
										}}>
										<img
											src={
												this.state.showQuickLinksAfterThankYouMsgFlag
													? CheckBoxChecked
													: unCheckBox
											}
											alt='checkbox'
											style={{ width: '20px', height: '20px' }}
											className='pointing-icon'
											onClick={() => {
												this.setState({
													showQuickLinksAfterThankYouMsgFlag:
														!this.state.showQuickLinksAfterThankYouMsgFlag,
												});
											}}
										/>
										<div
											style={{
												letterSpacing: '-0.21px',
												color: 'rgba(0,0,0,0.6)',
												fontSize: '14px',
												marginLeft: '6px',
											}}>
											Show quick links after this message
										</div>
									</div>
								</>
							)}
						</div>

						<div
							className='first-config-wrapper'
							style={{ paddingBottom: '44px' }}>
							<div className='frst-config-hearder'>
								AGENT UNAVAILABILITY DURING WORKING HOURS
							</div>
							<div
								style={{
									marginTop: '44px',
									display: 'flex',
									justifyContent: 'space-between',
								}}>
								<div className='config-msg-header'>
									Notify agents if users are waiting
								</div>
								<div>
									<img
										src={
											this.state.notifyAgentFlag ? selected_btn : unselected_btn
										}
										alt='unselectedbtns'
										className='pointing-icon'
										onClick={() => {
											this.setState({
												notifyAgentFlag: !this.state.notifyAgentFlag,
											});
										}}
									/>
								</div>
							</div>
							<div
								className='config-msg-usecase'
								style={{ marginTop: '10px', marginBottom: '22px' }}>
								If no agent for a queue is online, an email notification will be
								sent to all agents of that queue letting them know that users
								are waiting.
							</div>

							{this.state.notifyAgentFlag ? (
								<div style={{ marginTop: '20px', marginBottom: '26px' }}>
									<div
										className='sec-config-hearder'
										style={{ color: 'rgba(0, 0, 0, 0.7)', fontSize: '16px' }}>
										Email Address for email notifications
									</div>
									<div className='config-msg-usecase'>
										All email notifications will be sent to this address. You
										can setup email forwarding to automatically forward
										notifications to agents.
									</div>
									<input
										type='text'
										style={{
											width: '100%',
											marginTop: '-3px',
										}}
										className='config-msg-footer'
										value={this.state.toEmail}
										ref={this.myRef}
										placeholder='Enter email address'
										onChange={(event) => {
											this.setState({ toEmail: event.target.value });
										}}
										required={true}
									/>
									{this.state.toEmail === '' ||
										(this.checkEmailValidation(this.state.toEmail) && (
											<div className='config-empty-msg'>
												Please provide a valid email address
											</div>
										))}
								</div>
							) : null}

							<div
								style={{
									marginTop: '44px',
									display: 'flex',
									justifyContent: 'space-between',
								}}>
								<div className='config-msg-header'>
									Put chats in queue if no agents are online.
								</div>
								<div>
									<img
										src={this.state.queueFlag ? selected_btn : unselected_btn}
										alt='unselectedbtns'
										className='pointing-icon'
										onClick={() => {
											this.setState({
												queueFlag: !this.state.queueFlag,
											});
										}}
									/>
								</div>
							</div>
							<div
								className='config-msg-usecase'
								style={{ marginTop: '10px', marginBottom: '22px' }}>
								If no agents for a queue are online,handoffs and transfers will
								still happen for that queue.Users will be kept in queue until an
								agent responds.Email notifications will be sent to agents if
								enabled.
							</div>

							{this.state.queueFlag ? (
								<div style={{ marginTop: '20px', marginBottom: '26px' }}>
									<div
										className='sec-config-hearder'
										style={{ color: 'rgba(0, 0, 0, 0.7)', fontSize: '16px' }}>
										Handoff message for when no agents on online.
									</div>
									<div className='config-msg-usecase'>
										This message will be shown instead of the regular handoff
										message.
									</div>
									<input
										type='text'
										style={{
											width: '100%',
											marginTop: '-3px',
										}}
										className='config-msg-footer'
										value={this.state.queuehandoffMsg}
										ref={this.myRef}
										placeholder='E.g. All agents are currently offline, but we are trying to get an agent for you. Please stay online'
										onChange={(event) => {
											this.setState({ queuehandoffMsg: event.target.value });
										}}
										required={true}
									/>
									{this.state.queuehandoffMsg === '' && (
										<div className='config-empty-msg'>
											Please provide a handoff message for when no agents are
											online
										</div>
									)}
								</div>
							) : null}
						</div>
						<div
							className='first-config-wrapper'
							style={{ paddingBottom: '44px' }}>
							<div className='frst-config-hearder'>
								KNOWLEDGE BOT INTEGRATION
							</div>
							<div
								style={{
									marginTop: '44px',
									display: 'flex',
									justifyContent: 'space-between',
								}}>
								<div className='config-msg-header'>
									Integrate with Knowledge Bot
								</div>
								<div>
									<img
										src={
											this.state.collectKbotDetails
												? selected_btn
												: unselected_btn
										}
										alt='unselectedbtns'
										className='pointing-icon'
										onClick={() => {
											this.setState({
												collectKbotDetails: !this.state.collectKbotDetails,
											});
										}}
									/>
								</div>
							</div>
							<div
								className='config-msg-usecase'
								style={{ marginTop: '10px', marginBottom: '22px' }}>
								Add a Knowledge Bot to the chat dashboard. A Knowledge Bot sifts
								through thousands of your documents to find and surface relevant
								information for your agents while they are chatting with your
								users.
							</div>
							{this.state.collectKbotDetails && (
								<div className='kbot-w'>
									<div
										className='config-msg-header'
										style={{ marginTop: '20px' }}>
										Knowledge Bot ID
									</div>
									<div style={{ marginTop: '10px' }}>
										<input
											type='text'
											placeholder='Enter Knowledge Bot ID'
											ref={this.myKbotIdRef}
											style={{
												width: '100%',
												fontSize: '14px',
												fontFamily: 'Open Sans',
											}}
											onChange={(e) => {
												this.setState({
													kbotBotId: e.target.value,
												});
											}}
											value={this.state.kbotBotId}
											required={true}
										/>
									</div>
									{this.state.kbotBotId === '' ||
									this.state.kbotBotId === undefined ? (
										<div className='config-empty-msg'>
											Please enter a valid Knowledge Bot ID
										</div>
									) : null}
								</div>
							)}
						</div>
					</div>

					<div>
						<div className='first-config-wrapper'>
							<div className='frst-config-hearder'>MESSAGES</div>
							<div>
								{CONFIG_MESSAGES.map((msgData, index) => {
									var checkStatus = false;
									if (msgData.title === 'Handoff cancelled message') {
										checkStatus =
											this.state.showQuickLinksAfterhandoffCancelledMsgFlag;
									} else if (msgData.title === 'Handoff end message') {
										checkStatus =
											this.state.showQuickLinksAfterhandoffEndMsgFlag;
									}
									return (
										<div
											key={index}
											style={
												index === 0
													? {
															margin: '30px 0px 40px 0px',
													  }
													: {
															marginBottom: '40px',
													  }
											}>
											<div className='config-msg-header'>{msgData.title}</div>
											<div className='config-msg-usecase'>
												{msgData.useCase}
											</div>
											<input
												type='text'
												style={{
													width: '100%',
													marginTop: '0px',
												}}
												className={`config-msg-footer`}
												value={
													index === 0
														? this.state.WHAgentUnAvalibilityMsg
														: index === 1
														? this.state.NonWHAgentUnAvalibilityMsg
														: index === 2
														? this.state.handoffConfirmationMsg
														: index === 3
														? this.state.handoffMsg
														: index === 4
														? this.state.waitTimeResponse
														: index === 5
														? this.state.handoffCancelledMsg
														: index === 6
														? this.state.transferOrReleaseMsg
														: index === 7
														? this.state.handoffEndMsg
														: ''
												}
												placeholder={
													'e.g. ' + this.state.placeholders[4 + index]
												}
												onChange={(event) => {
													this.fetchValuesBasedonIndex(event, index);
												}}
												onFocus={(event) => event.target.select()}
												onClick={() => {
													this.selectText(index);
												}}
												required={true}
											/>

											{index === 0 &&
												this.state.WHAgentUnAvalibilityMsg === '' && (
													<div className='config-empty-msg'>
														Please provide an agent unavailability message
														(working hours)
													</div>
												)}
											{index === 1 &&
												this.state.NonWHAgentUnAvalibilityMsg === '' && (
													<div className='config-empty-msg'>
														Please provide an agent unavailability message
														(non-working hours)
													</div>
												)}
											{index === 2 &&
												this.state.handoffConfirmationMsg === '' && (
													<div className='config-empty-msg'>
														Please provide a handoff confirmation message
													</div>
												)}
											{index === 3 && this.state.handoffMsg === '' && (
												<div className='config-empty-msg'>
													Please provide a handoff message
												</div>
											)}
											{index === 4 && this.state.waitTimeResponse === '' && (
												<div className='config-empty-msg'>
													Please provide a wait time response
												</div>
											)}
											{index === 5 && this.state.handoffCancelledMsg === '' && (
												<div className='config-empty-msg'>
													Please provide a handoff cancelled message
												</div>
											)}
											{index === 6 &&
												this.state.transferOrReleaseMsg === '' && (
													<div className='config-empty-msg'>
														Please provide a transfer/release message
													</div>
												)}
											{index === 7 && this.state.handoffEndMsg === '' && (
												<div className='config-empty-msg'>
													Please provide a handoff end message
												</div>
											)}
											{msgData.title === 'Handoff cancelled message' && (
												<div
													style={{
														display: 'flex',
														alignItems: 'center',
														marginTop: '5px',
														marginBottom: '10px',
													}}>
													<img
														src={checkStatus ? CheckBoxChecked : unCheckBox}
														alt='checkbox'
														style={{ width: '20px', height: '20px' }}
														className='pointing-icon'
														onClick={() => {
															if (
																msgData.title === 'Handoff cancelled message'
															) {
																this.setState({
																	showQuickLinksAfterhandoffCancelledMsgFlag:
																		!this.state
																			.showQuickLinksAfterhandoffCancelledMsgFlag,
																});
															}
														}}
													/>
													<div
														style={{
															letterSpacing: '-0.21px',
															color: 'rgba(0,0,0,0.6)',
															fontSize: '14px',
															marginLeft: '6px',
														}}>
														Show quick links after this message
													</div>
												</div>
											)}
										</div>
									);
								})}
							</div>
						</div>
					</div>
				</div>
				<Modal
					title='Please check all values'
					isOpen={this.state.checkValidationPopup}
					onClose={() => {
						this.setState({
							checkValidationPopup: !this.state.checkValidationPopup,
						});
					}}
					source='general-tab'>
					<div>
						<div style={{ fontSize: '14px' }}>
							Please make sure that all values are filled in correctly in order
							to save
						</div>
						<div
							style={{
								display: 'flex',
								justifyContent: 'flex-end',
								marginTop: '10px',
							}}>
							<ThemedButtons
								title='Got it'
								theme='0'
								onClick={() => {
									this.setState({
										checkValidationPopup: !this.state.checkValidationPopup,
									});
								}}
							/>
						</div>
					</div>
				</Modal>{' '}
			</div>
		);
	}
}
